import { Pipe, PipeTransform } from '@angular/core';
import { ReportType } from '@safarilaw-webapp/feature/lpms/data-access';
@Pipe({
  name: 'reportMatterType'
})
export class ReportMatterTypePipe implements PipeTransform {
  transform(reportType: ReportType): string {
    switch (reportType) {
      case ReportType.AllMatter:
      case ReportType.Documents:
      case ReportType.Participants:
        return 'All';
      case ReportType.DocumentRequest:
        return 'Document Request';
      case ReportType.Garnishment:
      case ReportType.LedgerTransactions:
        return 'Garnishment';
      case ReportType.Litigation:
        return 'Litigation';
      case ReportType.OtherMatter:
        return 'Other Matter';
      case ReportType.ReviewerHistory:
        return 'Document Request';
      default:
        return '';
    }
  }
}
